import React from "react";
import IndexPage from "./404"

const IndexPageFR = () => (
  <IndexPage i18n="fr"/>
);

export default IndexPageFR;

